import { ReduceCompType } from '@craftjs/core';
import { SliderInputProps } from './SliderInput';
import { FormFileInputProps } from './FileInput';

export type ConditionalProps = {
  visibleIf?: string;
  enableIf?: string;
};

export type FormGeneralProps = ConditionalProps & {
  disabled?: boolean;
};

export type FormTitleProps = {
  title?: string;
  sectionTitle?: string;
  isCollapsible?: boolean;
  prefix?: string;
  tooltip?: string;
  description?: string;
};

export type ValidationProps = {
  isOptional?: boolean;
  startDateIsOptional?: boolean;
  endDateIsOptional?: boolean;
  minValue?: number | string;
  maxValue?: number | string;
  pattern?: string;
  maxLength?: number;
};

export type FormFieldProps = FormGeneralProps &
  ValidationProps &
  FormTitleProps & {
    dataKey: string;
    defaultValue?: any;
  };

export type FormFieldOption = {
  key: string;
  value: string;
  scoreWeight?: number;
};

export type FormFieldWithOptionsProps = FormFieldProps & {
  options: FormFieldOption[];
};

export type FormFieldWithScoreProps = {
  noAnswerScore?: number;
};

export type GlobalProps = ConditionalProps & {
  disabled?: boolean;
} & ValidationProps &
  FormTitleProps & {
    dataKey: string;
    defaultValue?: any;
  } & {
    options: FormFieldOption[];
  } & FormFieldWithScoreProps;

export const isFieldWithOptions = (fieldProps: any): fieldProps is FormFieldWithOptionsProps => !!fieldProps?.options;

export const isFieldWithExpression = (fieldProps: any): fieldProps is FormFieldWithOptionsProps => !!fieldProps.ex;

export const isSliderField = (fieldProps: any): fieldProps is SliderInputProps => {
  return fieldProps.step !== undefined && fieldProps.minValue !== undefined && fieldProps.maxValue !== undefined;
};

export const getResolvedName = (type: ReduceCompType) => {
  if (typeof type === 'string') return type;
  const hasResolvedName = 'resolvedName' in type;
  if (hasResolvedName) return type['resolvedName'];
  return type;
};

export const isDateRangeField = (nodeType: any) => {
  return getResolvedName(nodeType) === 'FormDateRangeInput';
};

export const isTimeField = (nodeType: any) => {
  return getResolvedName(nodeType) === 'FormTimeInput';
};

export const isTagInputField = (nodeType: any) => {
  return getResolvedName(nodeType) === 'FormTagInput';
};

export const isAttachmentsField = (fieldProps: any): fieldProps is FormFileInputProps =>
  fieldProps.addFileButtonText !== undefined;
